// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Atoms-Title-module--cls1--2lr1q","cls2":"Atoms-Title-module--cls2--31CVL Atoms-Title-module--cls1--2lr1q"};